import PageMetaData from "../../../components/PageMetaData";
import TopNavBar from "../../../components/TopNavBar";
import { HelmetProvider } from "react-helmet-async";
import { LayoutProvider } from "../../../context/useLayoutContext";
import { useParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { CommonServiceContext } from "../../../services/common/commonService";
import Loader from "../../../components/Loader";
import TextWithBreaks from "../../../components/common/TextWithBreaks";
import Footer from "../components/Footer";
import Calculator from "../components/Calculator";

const NewsInner = () => {
  const { id } = useParams();
  const { loading, getNewsById, newsItem } = useContext(CommonServiceContext);
  const [bgImageUrl, setBgImageUrl] = useState("");
  const [showCalculator, setShowCalculator] = useState(false);

  const handleShowCalculator = () => {
    setShowCalculator(!showCalculator);
  };
  const getNewsItemById = async (id) => {
    var response = await getNewsById(id);
  };

  useEffect(() => {
    if (id) {
      getNewsItemById(id);
    }
  }, []);

  useEffect(() => {
    if (newsItem && newsItem.bgImageUrl) {
      //console.log(newsItem.bgImageUrl);
      const charactersArray = newsItem.bgImageUrl.split("");
      const joinedCharacters = charactersArray.join("");
      //console.log(joinedCharacters);
      setBgImageUrl(joinedCharacters);
    }
  }, [newsItem]);

  return (
    <>
      {loading && <Loader />}
      <HelmetProvider>
        <LayoutProvider>
          <PageMetaData
            title={newsItem ? newsItem.name : "GEO Express | News"}
          />
          <TopNavBar
            position="fixed"
            menuItems={[
              ["მთავარი", "home", "/"],
              ["სერვისები", "services", "/services"],
              ["სიახლეები", "news", "/news", true],
              ["კონტაქტი", "contact", "/contact"],
              ["ხშირად დასმული კითხვები", "faqs", "/faq"],
              ["განსაბაჟებელი გზავნილები", "shipment", "/shipment"],
            ]}
            onCalculatorClick={handleShowCalculator}
          />
          <Calculator
            show={showCalculator}
            onClose={() => setShowCalculator(false)}
          />
          <div className="container">
            <section className="flex items-start justify-between h-auto mt-24">
              {/* <div
              className="w-2/5 h-full bg-cover bg-center"
              style={{ backgroundImage: `url(${bgImageUrl})` }}
            ></div> */}
              <img
                className="w-4/12 h-full bg-cover bg-center"
                alt="img"
                src={bgImageUrl}
              ></img>

              <div className="w-7/12 bg-white p-6 shadow-lg rounded-lg">
                <h2 className="text-2xl font-semibold text-gray-800">
                  {newsItem?.name}
                </h2>
                <h4 className="mt-4 text-gray-600">
                  <TextWithBreaks text={newsItem?.text} />
                </h4>
              </div>
            </section>
          </div>
          <Footer />
        </LayoutProvider>
      </HelmetProvider>
    </>
  );
};

export default NewsInner;
